<template>
<div>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="mx-1"
        v-bind="attrs"
        v-on="on"
        :color="color"
        :min-width="minWidth"
        :outlined="outlined"
        :rounded="rounded"
        :disabled="disabled"
        :text="text"
        :x-small="xsmall"
        :small="small"
        :large="large"
        :x-large="xlarge"
        :style="outlined ? 'border-width:2px;background-color:#FFFFFF;' : ''"
        @click="onDialogButtonClick">
        <v-icon v-if="prependIcon" class="ml-1">{{ prependIcon }}</v-icon>
        コース検索
        <v-icon v-if="appendIcon" class="ml-1">{{ appendIcon }}</v-icon>
      </v-btn>
    </template>

    <!-- RAW形式で文字列展開 -->
    <span v-html="message"></span>

  </v-tooltip>
  <dd-teikei-corse-search-dialog-for-lite
    :showDialog="showDialog"
    :itemList="itemList"
    :customHeaders="customHeaders"
    :abbreviatedDisplay="abbreviatedDisplay"
    :itemsPerPage="itemsPerPage"
    @close="onDialogClosed">
    <template v-if="$scopedSlots.body" #body="slotProps">
      <slot name="body" v-bind="slotProps" />
    </template>
  </dd-teikei-corse-search-dialog-for-lite>
</div>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VAutocomplete } from 'vuetify/lib'

import DdTeikeiCorseSearchDialogForLite from '@/components/DdTeikeiCorseSearchDialogForLite'

export default {
  name: 'DdTeikeiCorseSearchButton',
  extends: VAutocomplete,
  mixins: [inputMixin],
  props: {
    message: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'primary'
    },
    minWidth: {
      type: Number,
      default: 80
    },
    outlined: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: true
    },
    text: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: 'mdi-cloud-search'
    },
    /**
     * ボタンサイズ
     */
    xsmall: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    xlarge: {
      type: Boolean,
      default: false
    },
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: 999
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: {
      type: String,
      default: ''
    },
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 返却値カラム名
     */
    returnValueName: {
      type: String,
      default: ''
    },
    /**
     *
     */
    code: String,
    /**
     * Dialog用ヘッダリスト
     * @see VDataTable
     */
    customHeaders: Array,
    /**
     * Dialog表示タイトル
     */
    titleText: String,
    /**
    * 絞り込み対象カラム
    */
    searchColumns: Array,
    abbreviatedDisplay: {
      type: Boolean,
      default: false
    },
    itemsPerPage: {
      type: Number,
      default: 100
    }
  },
  components: {
    DdTeikeiCorseSearchDialogForLite
  },
  data: () => ({
    hasFocus: true,
    showDialog: false,
    invalidMessage: '',
    innerValue: {},
    autocompleteText: null,
    targetMaster: ''
  }),
  created () {
  },
  mounted () {
    console.log('DdCodeTextBox.mounted', this.itemList, this.lazyValue)
    this.innerValue = this.lazyValue
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
    // create targetMaster
    this.targetMaster = this.itemValue.replace('Cd', '')
  },
  watch: {
    itemList: function (newlist, oldlist) {
      console.log(newlist)
      this.itemList = newlist
    },
    value (n, o) {
      console.log('dd-code-text-box.watch(value)', o, n)
      if (o === n || n === undefined) { return }
      this.innerValue = n
      this.$emit('input', this.innerValue)
    },
    autocompleteText (value) {
      if (value === '') {
        this.innerValue = null
        this.$emit('input', this.innerValue)
      }
    }
  },
  computed: {
    phtext () {
      return !this.readonly ? 'コースNoまたはコース名で検索' : ' '
    },
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.readonly ? ' readonly-item' : this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        items: this.filteredItems,
        itemValue: this.itemValueName,
        itemText: 'text',
        clearable: false,
        clearIcon: '',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        filter: this.suggestFillter
      }
    },
    itemValueName () {
      return this.returnValueName === '' ? this.itemValue : this.returnValueName
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    },
    filteredItems () {
      if (this.itemList === undefined) { return [] }
      return this.itemList.map(e => {
        const result = {
          ...e,
          value: e[this.itemValueName],
          text: `${e[this.itemValue]} : ${e[this.itemText]}`
        }
        return result
      })
    }
  },
  methods: {
    onBlur: function (e) {
      console.log('DdCodeTextBox.onBlur', e)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
    },
    onInput: function (e) {
      console.log('DdCodeTextBox.onInput', e, e.target.value)
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      const val = e.target.value
      if (val === '') {
        this.value = { value: '' }
      }
    },
    onDialogButtonClick: function (e) {
      this.showDialog = true
      console.log('dialog opend', e)
    },
    onDialogClosed: function (e) {
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e.teikeiCourseNo

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this[controls.VALIDATE_METHOD]()
      this.teikeiCourseNoDialogSync(e)
    },
    /**
     * dialog選択時イベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    teikeiCourseNoDialogSync: function (e) {
      this.$emit('teikeiCourseNoDialogSync', e)
    },
    /**
     * 反映ボタン押下時イベント
     * @event input
     * @type {Event}
     * this.$emit('input', this.innerValue)
     */
    teikeiCourseNoSync: function (e) {
      this.$emit('teikeiCourseNoSync', e)
    },
    suggestFillter: function (item, queryText, itemText) {
      console.log('suggestFillter', item, queryText, itemText)
      const keys = !this.searchColumns ? Object.keys(item) : this.searchColumns
      for (let i = 0; i < keys.length; i++) {
        const v = String(item[keys[i]])
        if (v.indexOf(queryText) !== -1) { return true }
      }
      return false
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}

</script>
<style scoped>
</style>
